import { render, staticRenderFns } from "./PatientHealthIdentifiers.vue?vue&type=template&id=b3827e62&"
import script from "./PatientHealthIdentifiers.vue?vue&type=script&lang=js&"
export * from "./PatientHealthIdentifiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports